export const widgetApiEndpoints = {
  publicConfig: "/public/widget-config",
} as const;

export type BuildPublicConfigUrlInput = {
  apiBaseUrl: string;
  domain: string;
  projectApiKey: string;
};

export function buildPublicConfigUrl({
  apiBaseUrl,
  domain,
  projectApiKey,
}: BuildPublicConfigUrlInput) {
  const url = new URL(widgetApiEndpoints.publicConfig, apiBaseUrl);
  const params = new URLSearchParams({
    projectApiKey,
    domain,
  });

  url.search = params.toString();

  return url;
}
